<template>
  <div>
    <el-popover placement="bottom" class="quit">
      <span style="cursor: pointer" @click="quit"> 退出 </span>
      <el-button class="company-name" type="text" slot="reference">{{ userInfo.email || "西安自然成科技有限公司" }}
        <i class="el-icon-caret-bottom"></i>
      </el-button>
    </el-popover>
  </div>
</template>
<script>
import { notificationCenterList } from "@/api/index";
export default {
  data() {
    return {
      localStorage,
      userInfo: {},
      messageList: [
        {
          id: 0,
          type: "平台通知",
          date: "2020-12-09",
          title: "SDK隐私数据获取说明",
          content:
            "根据苹果App Store隐私规则（《用户隐私和数据使用》以及《应用商店上的应用程序隐私详细信息》），自2020年12月8日起，新App和App更新需向App Store Connect提交App隐私信息的答复。为便于您掌握优量汇SDK收集的数据类型、使用目的，优量汇为您提供相应说明文档，以便您在其App隐私信息答复中补充优量汇SDK数据收集和使用情况。",
        },
      ],
      userName: "",
      visible: false,
      activeIndex: "1",
      activeIndex2: "1",
    };
  },

  mounted() {
    this.userInfo = JSON.parse(localStorage.userInfo);
    this.getMessage();
  },
  methods: {
    getMessage() {
      notificationCenterList({}).then((res) => {
        if (res.code == 200) {
          let list = res.data.list;
          list.forEach((element) => {
            if (element.status == 2) {
              window.localStorage.setItem("isMessage", true);
            }
          });
        }
      });
    },
    goMessage() {
      this.$router.push("/message");
    },
    goIndex() {
      this.$router.push("/myindex");
    },
    goMessage() {
      this.$router.push("/message");
    },
    quit() {
      window.localStorage.removeItem("userInfo");
      window.localStorage.removeItem("accessToken");
      window.localStorage.removeItem("refreshToken");
      this.$router.push("/login");
    },
    handleClick() { },
    goContent(id) {
      this.$router.push({
        path: "messageDetail",
      });
    },
  },
};
</script>

<style scoped lang='less'>
.nav {
  color: #fff;
  position: absolute;
  left: 250px;
  display: flex;

  li {
    width: 100px;
    text-align: center;
    cursor: pointer;
  }
}

.messageLink {
  color: #3185fc;
  width: 90%;
  text-align: right;
  cursor: pointer;
}

.titleType {
  margin-right: 10px;
}

.messageTitle {
  color: #aaa;
  display: flex;
  width: 95%;
  font-size: 15px;
  justify-content: space-between;
}

.messageTitle:hover {
  color: #000;
}

.el-icon-bell {
  color: #fff;
  font-size: 16px;
  cursor: pointer;
}

.el-dropdown-link {
  cursor: pointer;
  color: #fff;
  margin-left: 20px;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.el-popover {
  padding: 20px 30px !important;
  box-shadow: 5px 5px 5px #ddd !important;

  span {
    cursor: pointer;
    text-align: center;
    display: block;
    width: 80%;
  }
}

.company-name {
  color: #000;
}

.el-button {
  position: relative;
  top: 2px;
  margin-left: 10px;
}

.share-button {
  font-size: 20px;
  padding: 0;
  background: none;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/Operation.vue